import React from "react";

const Footer = () => {
  return (
    <footer className="footer bg-dark mt-3 p-3" data-bs-theme="dark">
      <div className="text-center text-white">
        © {new Date().getFullYear()} All Rights Reserved.
      </div>
    </footer>
  );
};

export default Footer;
